import axios from "axios";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { Nav } from "react-bootstrap";
import Countdown from "react-countdown";
import { useLocation, useParams } from "react-router-dom";
import { serverInfo } from "../../../../App";
import roundBanner from "../../../../Assets/Images/Audition-images/auditionBanner.png";
import roundBg from "../../../../Assets/Images/Rounds/Round.png";
import ContdownTimerRender from "../../../../CustomHelper/ContdownTimerRender";
import EnrollAuditionTimer from "../EnrollAudition/EnrollAuditionTimer";
import Round1com from "../Round1Content/Round1com";
import "./AuditionBody.css";
import "./RoundBg.css";

export default function AuditionBody() {

  const { imageCdnUrl } = useContext(serverInfo);

  const location = useLocation();
  const params = useParams();
  const [loaded, setLoaded] = useState(false);

  const [audition, setAudition] = useState({});
  const [auditionRoundNum, setAuditionRoundNum] = useState(0);

  function pad(d) {
    return d < 10 ? "0" + d.toString() : d.toString();
  }

  const [hideInstruction, setHideInstruction] = useState(true);
  const [is_video_uploaded, setIsVideoUploaded] = useState("");
  const [roundInfo, setRoundInfo] = useState(null);
  const [roundInstruction, setRoundInstruction] = useState([]);
  const [videoDuration, setVideoDuration] = useState(40);
  const [countDownDate, setCountDownDate] = useState(new Date());

  const [selectedRound, setSelectedRound] = useState("");
  const [roundStartDate, setRoundStartDate] = useState(null);

  const start_date = moment(roundInfo?.round_start_date).format("LL");

  const showInstruction = (round_num) => {
    setSelectedRound(round_num);
    setHideInstruction(true);

    axios
      .get(`/api/user/audition/round-instruction/${audition.id}/${round_num}`)
      .then((res) => {
        if (res.data.status === 200) {
          setRoundInfo(res.data.roundInfo);
          setRoundInstruction(res.data.roundInstruction);
          setCountDownDate(new Date(moment(res.data.roundInfo?.round_end_date).format("LL")));
          setVideoDuration(res.data.roundInfo?.video_duration);

          setRoundStartDate(
            new Date(res?.data?.roundInfo?.round_start_date).getTime()
          );
          setLoaded(true);
        }
      });
  };

  useEffect(() => {
    console.log(location.state)
    setCountDownDate(new Date(moment(location.state.audition_end_date).format("LL")));
    axios
      .get(`api/user/audition/current_round_info/${params.slug}`)
      .then((res) => {
        if (res.data.status === 200) {
          setAudition(res.data.audition);
          // setRoundInfo(res.data.round_info);
          setRoundInstruction(res.data.round_instruction);
          setAuditionRoundNum(
            res.data.myRoundPass + 1 >= res.data.totalRound
              ? res.data.totalRound
              : res.data.myRoundPass + 1
          );
          setSelectedRound(
            res.data.myRoundPass + 1 >= res.data.totalRound
              ? res.data.totalRound
              : res.data.myRoundPass + 1
          );
        }
      });
  }, [params.slug]);


  return (
    <center>
      {location.state.pending === "pending" ? (
        <div className="container-fluid ">
          <div
            className="d-flex justify-content-center align-items-center my-2"
            style={{
              backgroundImage: `url(${audition.banner != null
                ? imageCdnUrl + audition.banner
                : roundBanner
                })`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
              minHeight: "25vh",
            }}
          >
            <div>
              <Countdown
                date={countDownDate}
                renderer={ContdownTimerRender}
              />
            </div>
          </div>
          <h1 className="audition-title p-2 head-line">{audition.title}</h1>
        </div>
      ) : (
        <>
          <div className="container-fluid ">
            <div
              className="d-flex justify-content-center align-items-center my-2"
              style={{
                backgroundImage: `url(${audition.banner != null
                  ? imageCdnUrl + audition.banner
                  : roundBanner
                  })`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
                minHeight: "25vh",
              }}
            ></div>
          </div>
        </>
      )}

      <div className="auditionMainContainer my-3 ">
        <div className="audition">
          {location.state.pending === "running" ? null : (
            <Nav variant="pills">
              <div className="container-fluid ">
                <div className="row">
                  {auditionRoundNum &&
                    [...Array(auditionRoundNum)].map((rule, index) => (
                      <div
                        key={index}
                        className="col-md-4 mb-2 pointer-link"
                        onClick={() => showInstruction(index + 1)}
                      >
                        <div>
                          <div
                            className="NavAudition my-2"
                            style={{ position: "relative" }}
                          >
                            <img
                              src={roundBg}
                              className="img-fluid"
                              width={"100%"}
                              alt=""
                            />
                            <div
                              className={`round-content ${index + 1 === selectedRound
                                ? "text-active"
                                : "text-inactive"
                                }`}
                            >
                              <h3 className="fw-bold">Round</h3>
                              <div>
                                <h4 className="fw-bold">{pad(index + 1)}</h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </Nav>
          )}
        </div>

        <div className="container-fluid auditonTabcontent my-2 p-0">
          {roundInfo !== null && roundStartDate <= new Date().getTime() ? (
            <>
              <Round1com
                audition={audition}
                roundInfo={roundInfo}
                instruction={roundInstruction}
                is_video_uploaded={is_video_uploaded}
              />
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    </center>
  );
}
